"use client";
import { setCookie } from "cookies-next/client";
import { signIn } from "next-auth/react";
import React from "react";
import LoadingModal from "~/components/loading-modal";
import { useRouter, useSearchParams } from "next/navigation";

const SIGN_IN_FAILED = "We could not sign you in to Bill Management.";
const TRY_AGAIN = "Try again";

export default function LoginPage() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const callbackUrl = searchParams?.get('callbackUrl');
  const callbackroute = searchParams?.get('callbackroute');
  const error = searchParams?.get('error');

  React.useEffect(() => {
    // Clear cookies
    setCookie("site", "", { maxAge: 0 });
    setCookie("bar-filter", "", { maxAge: 0 });

    // Don't trigger another sign-in if we're here because of an error
    if (error) return;

    // Determine which provider to use
    const shouldUseCognito = callbackUrl?.includes('cs-dashboard');

    async function handleAuth() {
      if (shouldUseCognito) {
        // Use Cognito for cs-dashboard
        await signIn("cognito", {
          callbackUrl: '/cs-dashboard', // Simplified callback URL
          redirect: true
        });
      } else {
        // Use Azure B2C for other routes
        // Prefer callbackUrl (set by NextAuth middleware) over callbackroute (legacy deep-link param)
        const cbroute = callbackUrl || callbackroute || '/';

        if (callbackroute) {
          setCookie("callbackroute", callbackroute, { maxAge: 3600 });
        }

        // Carry a deep-link scroll target through the auth round-trip in a cookie
        // (the URL fragment never reaches the server and OAuth strips it).
        if (window.location.hash) {
          setCookie("scrollTarget", window.location.hash, { maxAge: 300 });
        }

        if (process.env.NEXT_PUBLIC_AUTH == "IS4")
        {
          await signIn("ids4", {
            callbackUrl: cbroute
          });
        }
        else if (process.env.NEXT_PUBLIC_AUTH == "Auth0")
        {
          await signIn("auth0", {
            callbackUrl: cbroute
          });
        }
        else {
          await signIn("azure-ad-b2c", {
            callbackUrl: cbroute
          });
        }
      }
    }

    handleAuth();
  }, [callbackUrl, callbackroute, error]);

  if (error) {
    const retryParams = new URLSearchParams(searchParams?.toString());
    retryParams.delete("error");
    const retryQuery = retryParams.toString();
    const retryHref = retryQuery ? `/login?${retryQuery}` : "/login";

    return (
      <main className="bg-white h-screen w-screen flex flex-col items-center justify-center gap-4 p-8 text-center">
        <p>{SIGN_IN_FAILED}</p>
        <button type="button" className="underline" onClick={() => router.replace(retryHref)}>
          {TRY_AGAIN}
        </button>
      </main>
    );
  }

  return (
    <div className="bg-white h-screen z-50 absolute w-screen">
      <LoadingModal />
    </div>
  );
}